// extracted by mini-css-extract-plugin
module.exports = {"inactiveTitleBar":"BO","stepIndex":"CO","title":"DO","titleWrapper":"EO","changeSectionContainer":"FO"};